import styled from 'styled-components';

export const ChartLabelContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const ChartLabelIcon = styled.span`
  width: 8px;
  height: 24px;
  background-color: ${(props) => props.backgroundColor};
`;

export const ChartLabelValue = styled.span`
  font-size: 1rem;
  font-weight: 600;
`;

export const ChartLabelLabel = styled.span`
  font-size: 0.875rem;
`;
